import React, { useState } from "react";
import { rejectedPiecesData } from "../services/rejectedPiecesData";

const RejectedPiecesList = () => {
    const [filter, setFilter] = useState("");
    const [pieces, setPieces] = useState(rejectedPiecesData);

    const handleFilterChange = (e) => {
        setFilter(e.target.value.toLowerCase());
    };

    const filteredPieces = pieces.filter(
        (piece) =>
            piece.name.toLowerCase().includes(filter) ||
            piece.status.toLowerCase().includes(filter) ||
            piece.anomalyType.toLowerCase().includes(filter)
    );

    const handleSendToCorrection = (id) => {
        alert(`La pièce avec ID ${id} a été envoyée en correction.`);
        setPieces(
            pieces.map((piece) =>
                piece.id === id ? { ...piece, status: "En correction" } : piece
            )
        );
    };

    const handleRequestReplacement = (id) => {
        alert(`Un remplacement a été demandé pour la pièce avec ID ${id}.`);
        setPieces(
            pieces.map((piece) =>
                piece.id === id ? { ...piece, status: "Remplacement demandé" } : piece
            )
        );
    };

    const handleAddComment = (id) => {
        const comment = prompt("Ajoutez un commentaire pour cette pièce :");
        if (comment) {
            alert(`Commentaire ajouté pour la pièce avec ID ${id} : "${comment}"`);
        }
    };

    return (
        <div className="max-w-6xl mx-auto p-4">
            <h1 className="text-2xl font-bold mb-6">Gestion des pièces rejetées</h1>

            {/* Barre de recherche */}
            <div className="mb-4">
                <input
                    type="text"
                    placeholder="Rechercher par nom, statut ou type d’anomalie..."
                    value={filter}
                    onChange={handleFilterChange}
                    className="border border-gray-300 rounded p-2 w-full"
                />
            </div>

            {/* Tableau des pièces rejetées */}
            {filteredPieces.length > 0 ? (
                <table className="w-full border-collapse border border-gray-300">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="border border-gray-300 p-2">Nom de la pièce</th>
                            <th className="border border-gray-300 p-2">Type d’anomalie</th>
                            <th className="border border-gray-300 p-2">Statut</th>
                            <th className="border border-gray-300 p-2">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredPieces.map((piece) => (
                            <tr key={piece.id}>
                                <td className="border border-gray-300 p-2">{piece.name}</td>
                                <td className="border border-gray-300 p-2">{piece.anomalyType}</td>
                                <td className="border border-gray-300 p-2">{piece.status}</td>
                                <td className="border border-gray-300 p-2">
                                    <button
                                        onClick={() => handleSendToCorrection(piece.id)}
                                        className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                                    >
                                        Envoyer en correction
                                    </button>
                                    <button
                                        onClick={() => handleRequestReplacement(piece.id)}
                                        className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-700 mr-2"
                                    >
                                        Demander remplacement
                                    </button>
                                    <button
                                        onClick={() => handleAddComment(piece.id)}
                                        className="bg-gray-500 text-white px-3 py-1 rounded hover:bg-gray-700"
                                    >
                                        Ajouter un commentaire
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p className="text-center text-gray-500">Aucune pièce rejetée trouvée.</p>
            )}
        </div>
    );
};

export default RejectedPiecesList;
